<a seFeLink [href]="url" target="_top">
  <ng-content></ng-content>
</a>
